import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ACTIONS } from "../../lib/admin";

const KEYS = ["subscribe", "decline", "support"];
const fmt = (d) => d.slice(8, 10) + "/" + d.slice(5, 7);

export const DailyChart = ({ daily }) => {
  const rows = (Array.isArray(daily) ? daily : []).map((d) => ({ ...d, label: fmt(d.day) }));
  return (
    <div className="ad-card p-5" data-testid="daily-chart">
      <h2 className="ad-h2">Cliques por dia <span className="text-[#9DB0A5] font-normal">· últimos 14 dias</span></h2>
      {rows.length === 0 ? (
        <p className="text-sm text-[#9DB0A5] py-16 text-center">Ainda não há cliques registrados.</p>
      ) : (
        <div className="h-[260px] mt-4 -ml-3">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} barGap={2}>
              <CartesianGrid stroke="#22352B" vertical={false} />
              <XAxis dataKey="label" stroke="#9DB0A5" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis allowDecimals={false} stroke="#9DB0A5" fontSize={12} tickLine={false} axisLine={false} width={32} />
              <Tooltip cursor={{ fill: "rgba(212,255,58,.06)" }}
                contentStyle={{ background: "#101D17", border: "1px solid #22352B", borderRadius: 12, color: "#E8EFE9" }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {KEYS.map((k) => (
                <Bar key={k} dataKey={k} name={ACTIONS[k].label} fill={ACTIONS[k].color} radius={[4, 4, 0, 0]} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
